import React from 'react';
import { ItemToReturn } from '@src/models/returns';
import ItemImage from '../items/ItemImage';
import ItemDescription from '../items/ItemDescription';
import ItemQuantityCost from '../items/ItemQuantityCost';

interface ItemDetailsProps {
  item: ItemToReturn;
}

const ItemDetails = ({ item }: ItemDetailsProps) => {
  return (
    <div
      key={item.lineItemId}
      className="sui-flex sui-w-full sui-mb-6"
      data-testid="summary-item"
    >
      <ItemImage
        itemDescription={item?.itemDescription}
        imageUrl={item?.itemImageURL}
      />
      <ItemDescription
        brandName={item?.brandName}
        itemDescription={item?.itemDescription}
      />
      <ItemQuantityCost quantity={item?.returnQuantity} cost={item?.itemCost} />
    </div>
  );
};

export default ItemDetails;
